// extracted by mini-css-extract-plugin
export default {"link":"Agreement_link__wCS6C","placeHolderShimmer":"Agreement_placeHolderShimmer__OYaP0"};